import React, { Component, Fragment } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import { Subsections } from './'

import 'react-tabs/style/react-tabs.css'

class TabsSection extends Component {
    state = { tabIndex: 0 }

    renderTabList() {
        const { data } = this.props
        return (
            <TabList>
                {
                    data.map((tab, key) => {
                        return <Tab key={key}>{tab.title}</Tab>
                    })
                }
            </TabList>
        )
    }

    renderTabPanels() {
        const { data } = this.props
        return (
            <Fragment>
                {
                    data.map((tab, key) => {
                        return <TabPanel key={key}>
                                <Subsections subsections={tab.sections} />
                            </TabPanel>
                    })
                }
            </Fragment>
        )
    }

    renderTabs() {
        const { title, textBottom, textTop, css } = this.props
        return (
            <div className="container">
                <div className="container">
                    <div className={`row ${css}`}>
                        <div className=" text-center" style={{ margin: 'auto' }}>
                            {title && <h2 className="text-center lined">{title}</h2>}
                        </div>
                        <div className="col-lg-12">
                            {textTop && <div dangerouslySetInnerHTML={{ __html: textTop }} className="col-lg-12 text-center" />}
                            <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
                                {this.renderTabList()}
                                {this.renderTabPanels()}
                            </Tabs>
                            {textBottom && <div><hr className='hr-black' /><div dangerouslySetInnerHTML={{ __html: textBottom }} className="col-lg-12 text-muted text-center" /></div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <Fragment>
                {
                    this.props.data && <Fragment>{this.renderTabs()}</Fragment>
                }
            </Fragment>
        )
    }
}

export { TabsSection }


// WEBPACK FOOTER //
// ./src/components/sections/Tabs.js